import Api from 'api/index'

const config = {
  baseURL: '/api/app/v1',
}
const api = new Api(config)

api.getAccountAccesses = ({ networkType, ...rest }) =>
  api.get(`/${networkType}/agency-manager-clients`, {
    ...rest,
  })

api.fetchAccessById = ({ networkType, accessId, ...rest }) =>
  api.get(`/${networkType}/agency-manager-clients/${accessId}`, {
    ...rest,
  })

api.accountAccessCreate = ({ networkType, ...rest }) =>
  api.post(`/${networkType}/agency-manager-clients-manager`, {
    ...rest,
  })

api.updateAccountAccess = ({ networkType, accessId, ...rest }) =>
  api.patch(`/${networkType}/agency-manager-clients/${accessId}`, {
    ...rest,
  })

api.deleteAccountAccess = ({ networkType, accessId }) =>
  api.delete(`/${networkType}/agency-manager-clients/${accessId}`)

export default api
